import axios from "axios";

export function apiGetMarques(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/marques" + (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetMarque(instance, id, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/marques/" +
        id +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveMarque(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/marques", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateMarque(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/marques/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteMarque(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/marques/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
